import "./ApplicationsProcesses.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import ApplicationsHero from "./sections/ApplicationsHero";
import Applications from "./sections/Applications";
import Consultation from "./sections/Consultation";
import RelatedArticles from "./sections/RelatedArticles";
import Footer from "@/reusable_sections/Footer";
export default function ApplicationsProcessesPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="ApplicationsProcesses" />
      <ApplicationsHero />
      <Applications />
      <RelatedArticles />
      <Consultation />
      <Footer />
    </div>;
}